import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../../../store';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../../util/apiClient';
import { deleteSousModuleDroit, ISousModuleDroit, setObjSousModuleDroit, setOpenDialog, setSousModuleDroitsByModule, setValueComboEdit, setValueEdit } from './sousModuleDroitSlice';
import CommonListe from '../../../../components/Common/CommonListe';




const ListeSousModuleDroit = () => {


    //redux
    const dispatch = useDispatch()
    const { objModuleDroit } = useSelector((state: IReduxState) => state.modulesDroit);
    const { sousModuleDroits, sousModuleDroitsByModule } = useSelector((state: IReduxState) => state.sousModuleDroit);



    const deleteItem = async (item: any) => {
        try {
            const apiPayload = { idSousModuleDroit: item.idSousModuleDroit }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/supprimersousmoduledroit", apiPayload)
            if (res.status === 1) {
                dispatch(deleteSousModuleDroit(item.idSousModuleDroit))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };




    const getSousModuleDroitByModule = () => {
        dispatch(setSousModuleDroitsByModule(sousModuleDroits.filter((sousModule: ISousModuleDroit) => sousModule.idModuleDroit === objModuleDroit.idModuleDroit)))
    }
    useEffect(() => {
        getSousModuleDroitByModule()
    }, [objModuleDroit, sousModuleDroits]);


    const handleEditDialogOpen = (item: ISousModuleDroit) => {
        dispatch(setOpenDialog(true))
        dispatch(setObjSousModuleDroit(item))
        dispatch(setValueEdit(item.libSousModuleDroit))
        dispatch(setValueComboEdit(item.idSousModuleDroit))
    }

    return (
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
            <CommonListe
                data={sousModuleDroitsByModule}
                deleteItem={deleteItem}
                setItem={setObjSousModuleDroit}
                handleEditDialogOpen={handleEditDialogOpen}
            />
        </Box>
    );
}

export default ListeSousModuleDroit;
